import { instance } from "./axios";

export const getReportData = async (payload) => {
  try {
    return await instance.post("/reports", payload);
  } catch (error) {
    throw error;
  }
};
